<template>
  <div class="page404">404</div>
</template>

<script type="text/ecmascript-6">
export default {
  name: 'page404'
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/views/errorPages/page404.vue